import { render } from "./PlaceAutocomplete.vue?vue&type=template&id=6f5ed1aa"
import script from "./PlaceAutocomplete.vue?vue&type=script&lang=js"
export * from "./PlaceAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "./node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__